import React, { useEffect, useState } from "react";
import UnauthorizedIcon from "../images/UnauthorizedIcon.svg";
import "./PaymentMode.scss";
import { ButtonCustom } from "../UI/ButtonCustom/ButtonCustom";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { encryption } from "../common/encryption";
import { apiRequest } from "../services/apiService";
import { CONFIG } from "../common/constant";
import { message } from "antd";
import success from "../images/Success.png";

function RedirectAfterPayment() {
  const navigate = useNavigate();

  const [orderId, setOrderId] = useState();
  const [address, setAddress] = useState();
  const [token, setToken] = useState();
  const [countdown, setCountdown] = useState(1200); // 120 minutes in seconds

  // const location = useLocation();
  // const payDetails = location.state;
  // console.log("payDetails", payDetails);
  // const userDetails = useSelector((state) => state?.user?.user); // Adjust according to your actual state
  // console.log("USERDETAILS", userDetails);

  //   const handleDoneClick = () => {
  //     const redirectUrl = "https://google.com";
  //     if (redirectUrl) {
  //       window.location.replace(redirectUrl); // This will navigate to the new domain
  //     }
  //   };

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const token = queryParams.get("sessionId");
    setToken(token);
    const orderId = queryParams.get("orderId");
    setOrderId(orderId);
    const fromAddress = queryParams.get("fromAddress");
    setAddress(fromAddress);
    const timeStamp = queryParams.get("timeStamp");
    localStorage.setItem("countdownStartTime", timeStamp);

    console.log(
      token,
      "token",
      orderId,
      "orderId",
      fromAddress,
      "fromAddress",
      timeStamp,
      "timeStamp"
    );
  }, []);
  useEffect(() => {
    if (token && orderId && address) {
      pollPaymentStatus();
    }
  }, [orderId, address, token]);
  useEffect(() => {
    const savedStartTime = localStorage.getItem("countdownStartTime");
    if (savedStartTime) {
      const now = Math.floor(Date.now() / 1000); // Convert current time to seconds
      const elapsedTime = now - parseInt(savedStartTime); // Calculate elapsed time in seconds
      const newCountdown = Math.max(1200 - elapsedTime, 0); // Ensure countdown doesn't go below 0
      setCountdown(newCountdown);
    }
  }, []);
  const pollPaymentStatus = async () => {
    try {
      let payloadData = {
        payOrderId: orderId,
        fromAddress: address,
        status: "YES",
      };
      const enc = await encryption(JSON.stringify(payloadData));
      const securedData = { dataString: enc };
      const result = await apiRequest(
        `${CONFIG?.API_URL}payment/checkTransactionStatus`,
        "POST",
        securedData, // Use the relevant order ID
        token
      );

      if (result?.data?.blockchain_status === "confirmed") {
        message.success("Payment confirmed.");
        navigate("/payment-detail", { state: result?.data });
      } else if (result?.data?.blockchain_status === "failed") {
        message.error("Payment Failed.");
        navigate("/transaction-failed", { state: result?.data });
      }
    } catch (error) {
      console.error("Error checking payment status:", error);
    }
  };
  const formatTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${minutes}:${secs < 10 ? "0" : ""}${secs}`;
  };
  useEffect(() => {
    let interval;
    if (countdown > 0) {
      interval = setInterval(() => {
        setCountdown((prevCountdown) => prevCountdown - 1);

        // Poll API every 5 seconds
        if (countdown % 5 === 0) {
          pollPaymentStatus();
        }
      }, 1000);
    }

    if (countdown === 0) {
      clearInterval(interval); // Stop the countdown when it reaches 0
      //   message.error("Payment session expired.");
      localStorage.clear();

      //   navigate("/payment-detail", { state: result?.data });
      //   window.location.replace(userDetails?.redirect_url);
    }

    return () => clearInterval(interval); // Cleanup on unmount
  }, [countdown]);
  return (
    <div className="container">
      <div className="details commonBG">
        <img src={success} alt="Success" />
        {countdown > 0 ? (
          <>
            <h3>
              Your transaction is in process!
              <br /> Please wait for confirmation.
            </h3>
            <p>Time remaining: {formatTime(countdown)}</p>
          </>
        ) : (
          <>
            <h3>
              Your transaction is under process!
              <br />
              Please check later.
            </h3>
            {/* <p>Time remaining: {formatTime(countdown)}</p> */}
          </>
        )}

        {/* <ButtonCustom basicBtn label="Done" onClick={handleDoneClick} /> */}
      </div>
    </div>
  );
}

export default RedirectAfterPayment;
